import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatPeopleCount } from '@src/public/utils/format';
import { userIsLogin, userLogin } from '@src/public/utils/app';
import styles from './index.css';
import { Store } from '../../store';
import { postLikeComment } from '../../services';
import { LIKE_OPTION_INSERT, LIKE_OPTION_DEL, POSITION_MAIN, POSITION_SUB, POSITION_SUB_TOP } from '../../constants';

const cx = classNames.bind(styles);

const Like = ({ commentId, like, count, subjectId, position }) => {
    const store = Store.useContainer();
    const { states, changeStates } = store;
    const { likeMessage } = states;

    const [likeState, setLikeState] = useState(like);
    const [countState, setCountState] = useState(count);
    const [lock, setLock] = useState(false);

    const handleClick = () => {
        if (!userIsLogin()) {
            userLogin();

            return;
        }

        if (lock) {
            return;
        }

        setLock(true);

        const opType = likeState ? LIKE_OPTION_DEL : LIKE_OPTION_INSERT;

        postLikeComment({ commentId, opType, subjectId })
            .then(res => {
                if (res && res.data && res.data.code === 200) {
                    let newLike = likeState;
                    let newCount = countState;

                    setCountState(prev => {
                        if (likeState) {
                            newCount = prev - 1;
                        } else {
                            newCount = prev + 1;
                        }

                        return newCount;
                    });

                    setLikeState(prev => {
                        newLike = !prev;

                        return newLike;
                    });

                    if (position === POSITION_SUB || position === POSITION_SUB_TOP) {
                        changeStates({
                            likeMessage: { id: commentId, like: newLike, count: newCount },
                        });
                    }
                }
            })
            .catch(e => {
                console.error(e);
            })
            .finally(() => {
                setLock(false);
            });
    };

    useEffect(
        () => {
            const { id, like, count } = likeMessage;

            if (id === commentId && position === POSITION_MAIN) {
                setLikeState(like);
                setCountState(count);
                changeStates({ likeMessage: {} });
            }
        },
        [likeMessage],
    );

    return (
        <div className={cx('like', { liked: likeState })} onClick={handleClick}>
            <div className={styles.likeCount}>{countState ? formatPeopleCount(countState) : ''}</div>
            <div className={styles.likeIcon} />
        </div>
    );
};

Like.propTypes = {
    commentId: PropTypes.string,
    like: PropTypes.bool,
    count: PropTypes.number,
    subjectId: PropTypes.string,
    position: PropTypes.string,
};

export default errorBoundary(Like);
